import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, shareReplay, tap } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { BaseApiService } from '@app/services/api/base.service';
import { isDevMode } from '@angular/core';

export interface BackgroundInfo {
  first_name: string;
  last_name: string;
  location: string;
  birth_year: number | null;
  gender: string;
  ethnicity: string;
  school_grade: string;
  graduation_year: string;
  school_name: string;
  graduation_major: string;
  is_working: boolean;
  job_type: 'part_time' | 'full_time' | null;
  future_location: string;
  desired_location_google_place_id: string | null;
  desired_location_google_administrative_area_level_2: string | null;
}

export interface UserProfile {
  firstName: string;
  email?: string;
  lastName: string;
  biq?: boolean;
  backgroundInfo: BackgroundInfo;
  userId: string;

}

type EmailPreference = {
  emailType: string;
  subscribed: boolean;
};

type CreateEmailPreferencesInput = {
  emailPreferences?: EmailPreference[];
};

@Injectable({
  providedIn: 'root'
})
export class UserService extends BaseApiService {
  private cachedMe$: Observable<UserProfile> | null = null;
  private cachedMeValue: UserProfile | null = null;

  constructor(http: HttpClient) {
    const apiBaseUrl = isDevMode() ? '/users-api' : environment.usersApiUrl;
    super(http, apiBaseUrl);
  }

  getMe(): Observable<UserProfile> {
    if (!this.cachedMe$) {
      this.cachedMe$ = this.get<UserProfile>('me').pipe(
        tap(profile => this.cachedMeValue = profile),
        shareReplay(1),
      );
    }
    return this.cachedMe$;
  }

  // Returns the cached /me value synchronously, or null if not yet fetched. */
  getCachedMe(): UserProfile | null {
    return this.cachedMeValue;
  }

  // Clears the cached /me data so the next getMe() call fetches fresh from the API. */
  invalidateMeCache(): void {
    this.cachedMe$ = null;
    this.cachedMeValue = null;
  }

  createEmailPreferences(params: CreateEmailPreferencesInput): Observable<void> {
    return this.post<void>('email-preferences', params);
  }

  getEmailPreferences(): Observable<any> {
    return this.get<any>('email-preferences');
  }
}
